<template>
  <form id="newRecord" @submit.prevent="saveOrUpdateOrdenamiento">
    <c-422-errors :errors="errors" />
    <div class="mb-3">
      <label for="name" class="form-label">Nombre:</label>
      <input
        v-model="ordenamiento.name"
        class="form-control"
        id="name"
        required
      />
    </div>
    <c-primary-button class="w-100" :disabled="loading">
      Guardar
    </c-primary-button>
  </form>
</template>
<script>
import CPrimaryButton from "@/components/CPrimaryButton.vue";
import C422Errors from "@/components/C422Errors";
import { create, update, find } from "@/services/ordenamientos";
import { showNotification } from "@/services/notification";

export default {
  components: {
    C422Errors,
    CPrimaryButton,
  },
  data() {
    return {
      errors: {},
      loading: false,
      ordenamiento: {
        name: "",
      },
      ordenamientoId: this.$route.params.id,
    };
  },
  mounted() {
    this.getOrdenamiento();
  },
  methods: {
    getOrdenamiento() {
      if (!this.ordenamientoId) {
        return;
      }
      find(this.ordenamientoId).then((response) => {
        this.ordenamiento = response.data;
      });
    },
    saveOrUpdateOrdenamiento() {
      if (this.ordenamientoId) {
        this.updateOrdenamiento();
      } else {
        this.saveOrdenamiento();
      }
    },
    saveOrdenamiento() {
      create(this.ordenamiento).then(() => {
        showNotification(201);
        this.$router.push("/admin/configuraciones/ordenamientos");
      });
    },
    updateOrdenamiento() {
      update(this.ordenamientoId, this.ordenamiento).then(() => {
        showNotification(201);
        this.$router.push("/admin/configuraciones/ordenamientos");
      });
    },
  },
};
</script>
